import { loadStripe } from "@stripe/stripe-js";
import { Sentry } from "../sentryInstrument";

class StripeTokenizer {
  constructor(publishableKey, fieldMap, style, locale, onElementsReady) {
    this.canSubmit = false;
    this.tokenData = {};
    this.fields = Object.fromEntries(
      Object.entries(fieldMap).map(([fieldKey, field]) => [
        fieldKey,
        field instanceof HTMLElement
          ? field
          : document.querySelector(`[name=${field}]`)
      ])
    );
    this.paymentForm = this.fields.token.closest("form");
    loadStripe(publishableKey).then(stripe => {
      this.stripe = stripe;
      this.elements = stripe.elements({
        fonts: [{ cssSrc: "https://use.typekit.net/jsh0ewx.css" }],
        locale: locale
      });
      this.setUpElements(style);
    }); // TODO: handle errors
    this.errorMessageDiv = document.getElementById("card-error-message");
    window.stripeMountFields = this.mount;
    window.stripeUnmount = this.unmount;
    this.onElementsReady = onElementsReady;
	this.onFormSubmit = event => this.handleSubmit(event);
	this.onAddWait = event => this.handleAddWait(event);
  }

  setUpElements(style) {
    this.cardNumber = this.elements.create("cardNumber", { style });
    this.cardCvc = this.elements.create("cardCvc", { style: style });
    this.cardExpiry = this.elements.create("cardExpiry", { style: style });
    for (const element of [this.cardNumber, this.cardCvc, this.cardExpiry]) {
      element.on("blur", event => {
        element._parent.parentElement.classList.add("hasFocus");
		this.updateToken(true);
	  });
      element.on("change", event => {
        if (event.complete) {
          this.updateToken(true);
        }
      });
      element.on("blur", event =>
        element._parent.parentElement.classList.remove("hasFocus")
      );
    }
    this.mount();
    if (this.onElementsReady) {
      this.onElementsReady([this.cardNumber, this.cardCvc, this.cardExpiry]);
    }
  }

  mount() {
    this.cardNumber.mount(this.fields.cardNumber);
    this.cardCvc.mount(this.fields.ccvNumber);
    this.cardExpiry.mount(this.fields.expiry);
    this.paymentForm.addEventListener("submit", this.onFormSubmit);
    this.paymentForm.addEventListener("addWait", this.onAddWait);
  }

  unmount() {
    this.cardNumber.unmount();
    this.cardCvc.unmount();
    this.cardExpiry.unmount();
    this.paymentForm.removeEventListener("submit", this.onFormSubmit);
    this.paymentForm.removeEventListener("addWait", this.onAddWait);
  }

  handleSubmit(event) {
    if (!this.canSubmit) {
      event.preventDefault();
      this.updateToken();
      this.errorMessageDiv.scrollIntoView();
    }
  }

  handleAddWait(event) {
    if (!this.canSubmit) {
      event.target.querySelectorAll(".btn-group").forEach(element => {
        element.classList.remove("wait");
      });
    }
  }

  updateToken(hideErrors) {
	this.fields.token.value = "";
    this.canSubmit = false;
    this.errorMessageDiv.style = "display:none";
    this.errorMessageDiv.innerHTML = "";

    if (this.fields.region?.value) {
      const selectedOption = this.fields.region.querySelector(
        `option[value="${this.fields.region.value}"]`
      );
      if (selectedOption)
        this.tokenData.address_state = selectedOption.textContent.trim();
    }

    if (this.fields.country && this.fields.country.value) {
      const selectedOption = this.fields.country.querySelector(
        `option[value="${this.fields.country.value}"]`
      );
      if (selectedOption)
        this.tokenData.address_country = selectedOption.textContent.trim();
    }
    this.stripe.createToken(this.cardNumber, this.tokenData).then(result => {
      if (result?.error?.type == "validation_error" && !hideErrors) {
        this.fields.token.value = "";
        this.errorMessageDiv.style = "display:block";
        this.errorMessageDiv.innerHTML = result.error.message;
      } else if (result.token?.id) {
        this.errorMessageDiv.style = "display:none";
        this.errorMessageDiv.innerHTML = "";
        this.fields.token.value = result.token.id;
        this.canSubmit = true;
      } else if (result?.error?.type !== "validation_error") {
        this.fields.token.value = "";
        this.errorMessageDiv.style = "display:block";
        this.errorMessageDiv.innerHTML =
          "An unexpected error happened while processing your payment, please reload the page and try again.";
        const message = `Got unexpected error result from Stripe: ${result}`;
        if (Sentry && Sentry.captureMessage) {
          Sentry.captureMessage(message, "warning");
        } else {
          console.error(message);
        }
      }
    });
  }
}

window.StripeTokenizer = StripeTokenizer;
